import { type SelectionChange, SelectionModel } from '@angular/cdk/collections';
import { Component, inject, type OnDestroy, type OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { NgxFloatUiModule, NgxFloatUiTriggers } from 'ngx-float-ui';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import type { ILeiProfile } from '@core/models/app.model';
import { getCompanyNameFromLei } from '@helpers/get-compnay-name-from-lei';
import { LeiDetailsComponent } from '@shared/dialogs/lei-details-dialog/lei-details.component';

import { getLeiFromLeiProfile, getStatusFromLei } from '../helpers';

@Component({
  selector: 'ume-delete-user-dialog',
  templateUrl: './lei-search-dialog.component.html',
  styleUrls: ['./lei-search-dialog.component.scss'],
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    MatCheckboxModule,
    NgxFloatUiModule,
    LeiDetailsComponent,
  ],
})
export class LeiSearchDialogComponent implements OnInit, OnDestroy {
  readonly popTriggers = NgxFloatUiTriggers;

  public data: { list: ILeiProfile[]; title: string } = inject(MAT_DIALOG_DATA);
  public dialogRef: MatDialogRef<LeiSearchDialogComponent> = inject(
    MatDialogRef<LeiSearchDialogComponent>
  );
  public dialog: MatDialog = inject(MatDialog);

  title = 'Entity search results';
  list: ILeiProfile[] = [];
  selectedProfile!: ILeiProfile;

  displayedColumns: string[] = ['select', 'lei', 'legalName', 'status'];
  dataSource!: MatTableDataSource<ILeiProfile>;
  selection = new SelectionModel<ILeiProfile>(false, []);

  private _destroy$: Subject<void> = new Subject<void>();

  constructor() {
    this.list = this.data.list;

    if (this.data.title) {
      this.title = this.data.title;
    }
  }

  ngOnInit(): void {
    this.dataSource = new MatTableDataSource<ILeiProfile>(this.list);
    this.selection.changed
      .pipe(takeUntil(this._destroy$))
      .subscribe(({ added }: SelectionChange<ILeiProfile>) => {
        this.selectedProfile = added[0];
      });
  }

  getLei(leiProfile: ILeiProfile): string | null {
    return getLeiFromLeiProfile(leiProfile);
  }

  getName(leiProfile: ILeiProfile): string {
    return getCompanyNameFromLei(leiProfile);
  }

  getStatus(leiProfile: ILeiProfile): string {
    return getStatusFromLei(leiProfile);
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public makeSelection(): void {
    this.dialogRef.close(this.selectedProfile);
  }

  public checkboxLabel(row?: ILeiProfile): string {
    return `${this.selection.isSelected(row as ILeiProfile) ? 'deselect' : 'select'} row ${row?.attributes.lei}`;
  }
}
